import React, {Fragment} from 'react';
import axios from 'axios';
import ScrollIntoView from 'react-scroll-into-view';
import { toast } from 'react-toastify';

class Jobs extends React.Component{
    state ={
        role:'',
        location:'',
        experience:'select',
        jobs:[],
        total:0,
        page:1,
        date:Date.now(),
        search:false,
        perPage:0
    }
    
    getData = async()=>{
        try{
            let response = await axios.get('https://scrape.businesstoys.in/jobs?page=1',{
                headers:{
                    authenticate:localStorage.getItem("ivnj")
                }
            });
            if(response.data.jobs){
                this.props.updateLoading(false);
                this.setState({jobs:response.data.jobs || [], total:response.data.total || 0, perPage:response.data.perPage});
            }
        }catch(err){
            console.log(err);
        }
    }

    componentDidMount = ()=>{
       this.getData();
    }

    renderJobs = () => {
        
        return this.state.jobs.map((e,i)=>{
            return(
                <div className="jobs__container__card" key={i} >
                    <h3>{e.title}</h3>
                    <a  className={ !this.props.login ? "jobs__container__card--company blur" : "jobs__container__card--company" }
                        href={e.companyUrl} target="_blank" rel="noreferrer" >
                        {e.company}
                    </a>
                    <div className="jobs__container__card--details">
                        <div className="jobs__container__card--details--i">
                            <i className="fas fa-map-marker-alt"></i>
                            <p>{e.location}</p>
                        </div>
                        <div className="jobs__container__card--details--i">
                            <i className="fas fa-suitcase"></i>
                            <p>{e.experience}</p>
                        </div>
                        <div className="jobs__container__card--details--i">
                            <i className="fas fa-rupee-sign"></i>
                            <p>{e.salary}</p>
                        </div>
                    </div>
                    <p>
                        {e.description}
                    </p>
                    <div className="jobs__container__card__apply" >
                        <div className="jobs__container__card__apply--time">
                            {e.postDate }
                        </div>
                        <div className="jobs__container__card__apply--link">
                            <a  style={{cursor:'pointer'}} 
                                onClick={()=>this.onLinkClick(e.jobUrl)} rel="noreferrer" >
                                Apply Now
                                <i className="fas fa-chevron-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            )
        })
    }

    onNextPage =async() => {
        if(this.state.page >= 1 && this.state.page < this.state.total ){
            try{
                this.props.updateLoading(true);
                    let response = await axios.get(`https://scrape.businesstoys.in/jobs?page=${this.state.page + 1}`,{
                        headers:{
                            authenticate:localStorage.getItem("ivnj")
                        }
                    });
                    if(response.data.jobs){
                        this.props.updateLoading(false);
                        this.setState({jobs:response.data.jobs || [], total:response.data.total || 0 , page:this.state.page + 1, perPage:response.data.perPage});
                    }
            }catch(err){
                console.log(err);
            }
        }
    }

    onPreviousPage = async () =>{
        if(this.state.page > 1 && this.state.page < this.state.total ){
            try{
                    this.props.updateLoading(true);
                    let response = await axios.get(`https://scrape.businesstoys.in/jobs?page=${this.state.page - 1}`,{
                        headers:{
                            authenticate:localStorage.getItem("ivnj")
                        }
                    });
                    if(response.data.jobs){
                        this.props.updateLoading(false);
                        this.setState({jobs:response.data.jobs || [], total:response.data.total || 0 , page:this.state.page - 1, perPage:response.data.perPage});
                    }
            }catch(err){
                console.log(err);
            }
        }
    }

    searchButtonClick = async() => {
        try{
            this.props.updateLoading(true);
            let response = await axios.get(`https://scrape.businesstoys.in/search?role=${this.state.role}&exp=${this.state.experience}&loc=${this.state.location}`,{
                headers:{
                    authenticate:localStorage.getItem("ivnj")
                }
            });
            if(response.data.jobs){
                toast.success('Filter Applied',{
                    position: "top-center",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                })
                this.props.updateLoading(false);
                this.setState({jobs:response.data.jobs || [], total:response.data.total || 0, search:true, page:1, });
            }
        }catch(err){
            console.log(err);
        }
    }

    onLinkClick = (link) => {
        if(link !== 'Login to view') window.open(link, '_blank');
        else this.props.updateModal(true);
    }

    render(){
    
        return(
            <Fragment>
                <h2 className="jobs__title" id="job-title" >{this.state.total} - Jobs </h2>
                <section className="jobs" >
                    <div className="jobs__sticky">
                        <h2>
                            <i className="fas fa-filter"></i>
                            Filters
                        </h2>
                        <div className="jobs__sticky--ip">
                            <label>
                                Role
                            </label>
                            <input type="text" 
                                value={this.state.role} 
                                onChange={e=>this.setState({role:e.target.value})} 
                                name="role" 
                                placeholder="e.g. Data Science" />
                        </div>
                        <div className="jobs__sticky--ip">
                            <label>
                                Location
                            </label>
                            <input type="text" 
                                value={this.state.location} 
                                onChange={e=>this.setState({location:e.target.value})}
                                name="location" 
                                placeholder="e.g. Bangalore" />
                        </div>
                        <div className="jobs__sticky--ip">
                            <label>
                                Experience
                            </label>
                            <select 
                                value={this.state.experience} 
                                onChange={async(e)=>{
                                    await this.setState({experience:e.target.value})
                                }} >
                                <option disabled value="select" >Select Your Experience</option>
                                <option value="0-" >Fresher</option>
                                <option value="-3" >Less than 3 Years</option>
                                <option value="3-" >More than 3 Years</option>
                            </select>
                        </div>
                        <ScrollIntoView selector="#job-title" className="jobs__sticky--apply" onClick={this.searchButtonClick} > 
                            Apply 
                        </ScrollIntoView>        
                    </div>
                    <div className="jobs__container">
                        {this.renderJobs()}
                        <div className="jobs__paginate" style={{display:this.state.search ? 'none' :'flex'}}>
                                <ScrollIntoView selector="#job-title" onClick={this.onPreviousPage} >
                                    <i className="fas fa-chevron-left"  ></i>
                                </ScrollIntoView>
                                <p>{this.state.page} / {Math.floor(this.state.total / 20) }</p>
                                <ScrollIntoView selector="#job-title" onClick={this.onNextPage} >
                                    <i className="fas fa-chevron-right"  ></i>
                                </ScrollIntoView>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
};

export default Jobs;